'use client';

import { useTheme } from '@emotion/react';
import { City } from '../../../models';
import { Sitemap } from '../../../models/sitemap';
import { Container } from '../../layout/Container';
import { DEVICE_SCREENS_MAX_STRING } from '../../../lib/consts';
import { BreadCrumbs } from '../../blocks/BreadCrumbs';
import { H1, H2, H3, H4 } from '../../styled/typography';
import { BLOG_DOMAIN } from '../../../lib/api/apiUrl';
import { Link } from '../../Link';

function SiteMapPage({
  currentCity,
  sitemapItems,
}: {
  currentCity: City;
  sitemapItems: {
    catalog: Sitemap;
    compilations: Sitemap;
    places: Sitemap;
    persons: Sitemap;
  };
}) {
  const theme = useTheme();
  return (
    <Container
      css={{
        padding: '15px 14px',
        [DEVICE_SCREENS_MAX_STRING.md]: {
          padding: '15px 16px',
        },
      }}
    >
      <BreadCrumbs
        currentCity={currentCity}
        items={[{ title: 'Карта сайта' }]}
      />
      <H1
        css={{
          fontFamily: 'Montserrat',
          color: '#282828',
          fontWeight: 700,
          marginTop: 24,
          [DEVICE_SCREENS_MAX_STRING.md]: {
            marginTop: 12,
          },
        }}
      >
        Карта сайта - {currentCity.title} - Горбилет
      </H1>
      <main css={{ fontFamily: 'Golos', color: theme.colors.black }}>
        <div
          css={{
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
            paddingTop: 16,
          }}
        >
          <H2
            css={{
              ':hover': {
                textDecoration: 'underline',
              },
            }}
          >
            <Link href={sitemapItems.catalog.link}>
              {sitemapItems.catalog.title}
            </Link>
          </H2>
          <div
            css={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr 1fr',
              gap: 24,
              [DEVICE_SCREENS_MAX_STRING.sm]: {
                gridTemplateColumns: '1fr',
              },
            }}
          >
            {sitemapItems.catalog.children_data.map((category) => (
              <div
                key={category.id}
                css={{ display: 'flex', flexDirection: 'column', gap: 12 }}
              >
                <H3
                  css={{
                    ':hover': {
                      textDecoration: 'underline',
                    },
                  }}
                >
                  <Link href={category.link}>{category.title}</Link>
                </H3>
                {category.children_data.map((subcategory) => (
                  <H4
                    css={{
                      ':hover': {
                        textDecoration: 'underline',
                      },
                    }}
                    key={subcategory.id}
                  >
                    <Link href={subcategory.link}>{subcategory.title}</Link>
                  </H4>
                ))}
              </div>
            ))}
          </div>
          <H2
            css={{
              ':hover': {
                textDecoration: 'underline',
              },
            }}
          >
            <Link href={sitemapItems.compilations.link}>
              {sitemapItems.compilations.title}
            </Link>
          </H2>
          <div css={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {sitemapItems.compilations.children_data.map((compilation) => (
              <div key={compilation.id}>
                <H4
                  css={{
                    ':hover': {
                      textDecoration: 'underline',
                    },
                  }}
                >
                  <Link href={compilation.link}>{compilation.title}</Link>
                </H4>
              </div>
            ))}
          </div>
          <H2
            css={{
              ':hover': {
                textDecoration: 'underline',
              },
            }}
          >
            <Link href={sitemapItems.places.link}>
              {sitemapItems.places.title}
            </Link>
          </H2>
          <div css={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {sitemapItems.places.children_data.map((place) => (
              <div key={place.id}>
                <H4
                  css={{
                    ':hover': {
                      textDecoration: 'underline',
                    },
                  }}
                >
                  <Link href={place.link}>{place.title}</Link>
                </H4>
              </div>
            ))}
          </div>
          <H2
            css={{
              ':hover': {
                textDecoration: 'underline',
              },
            }}
          >
            <Link href={sitemapItems.persons.link}>
              {sitemapItems.persons.title}
            </Link>
          </H2>
          <div css={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {sitemapItems.persons.children_data.map((person) => (
              <div key={person.id}>
                <H4
                  css={{
                    ':hover': {
                      textDecoration: 'underline',
                    },
                  }}
                >
                  <Link href={person.link}>{person.title}</Link>
                </H4>
              </div>
            ))}
          </div>
          <H2
            css={{
              ':hover': {
                textDecoration: 'underline',
              },
            }}
          >
            <Link href={[BLOG_DOMAIN, 'blog', ''].join('/')}>Блог</Link>
          </H2>
        </div>
      </main>
    </Container>
  );
}

export default SiteMapPage;
